// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2pzeg","header":"MessagesList_header__20ida","chat":"MessagesList_chat__T3V1B"};